import { apiSlice } from "../../app/apiSlice";
import configUrls from "../../config/configUrls";
import { TipoDocumento } from "../../types/tipoDocumento/TipoDocumento";


const endpointUrl = configUrls.TIPO_DOCUMENTO_EP



function createTipoDocumento(obj: TipoDocumento) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateTipoDocumento(obj: TipoDocumento) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteTipoDocumento({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getTipoDocumentos(search: string) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}




export const tipoDocumentoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getTipoDocumento: query<TipoDocumento, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["TipoDocumento"],
        }),

        getTipoDocumentos: query<TipoDocumento[], string>({
            query: getTipoDocumentos,
            providesTags: ["TipoDocumento"],
        }),



        createTipoDocumento1: mutation<TipoDocumento, TipoDocumento>(
            {
                query: createTipoDocumento,
                invalidatesTags: ["TipoDocumento"]
            }),


        createTipoDocumento: mutation<TipoDocumento, TipoDocumento>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,
                    method: 'POST',
                    body: obj,
                }),
                invalidatesTags: ["TipoDocumento"]
            }),

        updateTipoDocumento: mutation<TipoDocumento, TipoDocumento>({
            query: updateTipoDocumento,
            invalidatesTags: ["TipoDocumento"]
        }),

        deleteTipoDocumento: mutation<TipoDocumento, { id: string }>(
            {
                query: deleteTipoDocumento,
                invalidatesTags: ["TipoDocumento"],
            }),


    }),

});
export const {
    useGetTipoDocumentoQuery,
    useGetTipoDocumentosQuery,
    useCreateTipoDocumentoMutation,
    useUpdateTipoDocumentoMutation,
    useDeleteTipoDocumentoMutation,
    useCreateTipoDocumento1Mutation,
} = tipoDocumentoApiSlice